import { FlowType, StepType } from "@models/doctype";
import type { FlowStepFormData } from "@utils/builders/flowConfig";

const llmStep = (stepOrder: number, stepType: string): FlowStepFormData => ({
  stepOrder,
  stepType,
  llmStepConfig: {
    provider: "",
    systemPrompt: "",
    userPrompt: "",
    modelName: "",
  },
});

const ocrStep = (stepOrder: number): FlowStepFormData => ({
  stepOrder,
  stepType: StepType.OCR,
  ocrStepConfig: {
    provider: "",
    modelName: "",
  },
});

const llmStepWithAgents = (stepOrder: number): FlowStepFormData => ({
  stepOrder,
  stepType: StepType.DATA_EXTRACTION,
  llmStepConfig: {
    provider: "",
    systemPrompt: "",
    userPrompt: "",
    modelName: "",
    executions: [],
  },
});

export const generateStepsForFlowType = (
  flowType: string,
): FlowStepFormData[] => {
  switch (flowType) {
    case FlowType.FILE_ONLY:
      return [llmStep(1, StepType.DATA_EXTRACTION)];

    case FlowType.BASIC:
      return [ocrStep(1), llmStep(2, StepType.DATA_EXTRACTION)];

    case FlowType.PAGE_DETECTION:
      return [
        llmStep(1, StepType.PAGE_DETECTION),
        ocrStep(2),
        llmStep(3, StepType.DATA_EXTRACTION),
      ];

    case FlowType.NO_OCR_PAGE_DETECTION:
      return [
        llmStep(1, StepType.PAGE_DETECTION),
        llmStep(2, StepType.DATA_EXTRACTION),
      ];

    case FlowType.PARALLEL:
      return [
        llmStep(1, StepType.PAGE_DETECTION),
        ocrStep(2),
        llmStepWithAgents(3),
      ];

    default:
      return [];
  }
};
